import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  messageSubject = new ReplaySubject<string>();

  setUnreadMessages(message: string) {
    this.messageSubject.next(message);
  }
}
